import { render, staticRenderFns } from "./OrderCartItem.vue?vue&type=template&id=6aa1a126&scoped=true"
import script from "./OrderCartItem.vue?vue&type=script&lang=ts"
export * from "./OrderCartItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderCartItem.vue?vue&type=style&index=0&id=6aa1a126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1a126",
  null
  
)

export default component.exports